<template>
    <v-card flat style="min-height:600px">
      <div v-show="status === 'choice' && !isLoading">
        <v-btn
          @click="$router.push({name: 'UserTop', params: {id: loginUid}})"
          small flat
        ><v-icon>keyboard_arrow_left</v-icon>&nbsp;マイページへ戻る</v-btn>
            <!-- 食品選択 -->
          <h2 style="margin-left:16px">修正する食品を選択してください</h2>
        <v-container>
          <food-card-min
            v-for="(t, id) in rank" :key=id
            @onFoodCardMinClick="onChoice(id)"
            :name="t.name"
            :imageurl="t.imageurl"
            :label="`${id+1}位`"
            style="margin-bottom:5px;"
          ></food-card-min>
        </v-container>
      </div>
      <div v-if="status === 'hikaku'">
        <v-btn
          @click="status='choice'"
          small flat
        ><v-icon>keyboard_arrow_left</v-icon>&nbsp;食品を選びなおす</v-btn>
        <karasa-hikaku-form
          @onFinish='onHikakuFinish'
          @onMessage='onMessage'
        ></karasa-hikaku-form>
      </div>
        <div v-show="isLoading" style="text-align:center;height:400x;padding-top:150px;">
          <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
        </div>
    </v-card>
</template>

<script>
import { db } from '@/main'
import getImageUrl from '@/assets/js/getImageUrl.js'
import FoodCardMin from '@/components/card/FoodCardMin.vue'
// import KarasaHikakuForm from '@/components/form/KarasaHikakuForm.vue'
import KarasaHikakuForm from '@/components/form/KarasaHikakuForm2.vue'

// @ is an alias to /src
export default {
  name: 'RankEdit',
  data () {
    return {
      status: 'choice',
      isLoading: false,
      rank: []
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    },
    loginUid () {
      return this.$store.state.user.uid
    },
    isOwner () {
      if (this.loginUid === this.uid) return true
      return false
    }
  },
  watch: {
    '$route' () {
      this.init()
    },
    'status' () {
      this.init()
    }
  },
  filters: {
    displayDate (value) {
      let date = new Date()
      if (value.seconds) {
        date.setTime(value.seconds * 1000)
      } else {
        date.setTime(value)
      }      
      return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`
    },
    changeBr: function (value) {
      return value.replace(/\r?\n/g, '<br>')
    }
  },
  created () {
  },
  mounted () {
    this.getRank()
    console.log(this.loginUid)
  },
  methods: {
    init () {
      window.scrollTo(0, 0)
    },
    async getRank () {
      this.isLoading = true
      this.rank = []
      let response = await db.collection('rank').where('user.uid', '==', this.loginUid).get()
      response.forEach(doc => {
        let rankdatas = doc.data()
        for (let i = 0; i < rankdatas.foods.length; i++) {
          let obj = rankdatas.foods[i]
          obj.imageurl = getImageUrl.get('food_thumbs', obj.id, obj.images[0])
          this.rank.push(obj)
        }
      })
      this.isLoading = false
    },
    onChoice (index) {
      let food = this.rank[index]
      this.$store.commit('setTempId', food.id)
      this.$store.commit('setTempFoodData', food)
      this.$store.commit('setTempImages', [food.imageurl])
      this.$store.commit('setTempPostId', food.postId)
      this.status = 'hikaku'
    },
    scrollIni () {
      window.scrollTo(0, 0)
    },
    onHikakuFinish () {
      this.onFinish()
    },
    onFinish () {
      this.$store.commit('initPost')
      let message = {
        group: 'messageBottom',
        type: 'success',
        title: 'Thank you !!',
        text: '辛さランクを更新しました'
      }
      this.onMessage(message)
      this.status='choice'
      this.getRank()
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }

  },
  components: {
    FoodCardMin,
    KarasaHikakuForm
  },
  head: {
    title () {
      return {
        inner: `${this.headerUserName}さんのページ`,
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '激辛口コミグルメサイトの初期登録ページです'}
      ]
    },
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  }
}
</script>

<style scoped>
</style>
>